export default __webpack_public_path__ + "static/media/IU_Home5.17c09395.png";